// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { LayoutComponent } from "@ifeng-fe/lowcode_basic/src/components/layout/LayoutComponent/index.tsx";

import { ImageLink } from "@ifeng-fe/lowcode_basic/src/components/popular/ImageLink/index.tsx";

import { Container } from "@ifeng-fe/lowcode_basic/src/components/layout/Container/index.tsx";

import { Title } from "@ifeng-fe/lowcode_basic/src/components/popular/Title/index.tsx";

import { NewsList_11 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_11/index.tsx";

import { VideoList_1 } from "@ifeng-fe/lowcode_basic/src/components/video/VideoList_1/index.tsx";

import { NewsList_12 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_12/index.tsx";

import { Row } from "@ifeng-fe/lowcode_basic/src/components/layout/Row/index.tsx";

import { Col } from "@ifeng-fe/lowcode_basic/src/components/layout/Col/index.tsx";

import { Swiper_4 } from "@ifeng-fe/lowcode_basic/src/components/Swiper/Swiper_4/index.tsx";

import { Footer } from "@ifeng-fe/lowcode_basic/src/components/popular/Footer/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div
        style={{ overflowX: "hidden" }}
        hoverStyle=""
        nodeId="node_dockcviv8fo1"
      >
        <LayoutComponent
          isCenter={true}
          nodeId="node_ocl8lkjm3v1i"
          hoverStyle=""
        >
          <ImageLink
            image="https://x0.ifengimg.com/ucms/2024_44/A59581B79CBAB9BE034F6597F5A1DF7A94C82A65_size215_w1920_h350.jpg"
            url=""
            isBlock={true}
            width={300}
            height={350}
            objectFit="cover"
            style={{
              display: "block",
              backgroundPositionX: "center",
              backgroundPositionY: "center",
              backgroundSize: "cover",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
            hoverStyle=""
            nodeId="node_ocl8mrdjw62"
          />
        </LayoutComponent>
        <Container
          width={1200}
          isCenter={true}
          hoverStyle=""
          nodeId="node_ocl8lkjm3v1n"
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8u8dees77"
            hoverStyle=""
            style={{ paddingBottom: "20px" }}
          >
            <Title
              text="01 700万患者心声"
              height={50}
              image="https://x0.ifengimg.com/ucms/2024_44/9545C89EE879A9C743743B61C88DA0DC7AFF5117_size1_w1000_h70.png"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "24px",
                color: "#ffffff",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm3"
              textIconHeightFull={true}
            />
            <NewsList_11
              chips={{
                newsChip: {
                  title: "新闻内容",
                  id: "",
                  type: "recommend",
                  defaultId: "285873",
                  uuid: "04b973b4",
                },
              }}
              colNum={1}
              colPadding={35}
              showColBorder={true}
              itemStyle={{ paddingTop: "15px", paddingBottom: "15px" }}
              itemAlignCenter={false}
              itemHoverColor="#ba2636"
              showThumbnail={true}
              thumbnailWidth={122}
              thumbnailHeight={122}
              showThumbnailHoverScale={true}
              titleStyle={{
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
              }}
              showSummary={true}
              summaryStyle={{
                color: "#666666",
                fontSize: "14px",
                lineHeight: "24px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              newsChip={{
                $data: true,
                id: "288568",
                type: "recommend",
                title: "新闻内容",
                format: {
                  filter: [
                    "thumbnails",
                    "title",
                    "type",
                    "url",
                    "base62Id",
                    "summary",
                    "children",
                    "position",
                    "newsTime",
                  ],
                },
                default: { type: "recommend", id: "285873" },
                uuid: "f1ea01c4",
                force: 1730094570695,
              }}
              showTime={false}
              nodeId="node_ocl75lh7p87"
              skin={0}
              timeStyle={{
                color: "#666666",
                fontSize: "12px",
                lineHeight: "24px",
              }}
            />
            <Title
              text="02 走进公益微电影"
              height={50}
              image="https://x0.ifengimg.com/ucms/2024_44/9545C89EE879A9C743743B61C88DA0DC7AFF5117_size1_w1000_h70.png"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "24px",
                color: "#ffffff",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm3"
              textIconHeightFull={true}
            />
            <VideoList_1
              videoChip={{
                $data: true,
                id: "288569",
                type: "recommend",
                title: "视频列表",
                format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                default: { type: "recommend", id: "285924" },
                uuid: "cfd4583e",
                force: 1730172067174,
              }}
              width={580}
              height={457}
              autoPlay={false}
              controls={true}
              hoverColor="#ba2636"
              skin={1}
              continuePlay={false}
              listIcon="https://x2.ifengimg.com/fe/custom/xghg25/video.559ac347.png"
              listIconWidth={14}
              listIconHeight={9}
              listStyle={{
                paddingLeft: "19px",
                paddingRight: "10px",
                height: "48px",
                fontSize: "14px",
                color: "#2b2b2b",
                lineHeight: "48px",
              }}
              nodeId="node_ocl75lh7p8b"
            />
            <Title
              text="03 科学认识银屑病"
              height={50}
              image="https://x0.ifengimg.com/ucms/2024_44/9545C89EE879A9C743743B61C88DA0DC7AFF5117_size1_w1000_h70.png"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "24px",
                color: "#ffffff",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm3"
              textIconHeightFull={true}
            />
            <NewsList_12
              newsChip={{
                $data: true,
                id: "288548",
                type: "recommend",
                title: "新闻内容",
                default: { type: "recommend", id: "285873" },
                uuid: "93c7edf8",
                force: 1730100614138,
              }}
              colNum={4}
              thumbnailWidth={268}
              thumbnailHeight={180}
              showThumbnailHoverScale={false}
              formatImageType={3}
              isHasTitle={true}
              titleRows={2}
              titleHoverColor="#ba2636"
              titleStyle={{
                paddingTop: "15px",
                paddingBottom: "10px",
                marginLeft: "15px",
                marginRight: "15px",
                borderBottomStyle: "solid",
                borderBottomWidth: "1px",
                borderBottomColor: "#e8e8e8",
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
              }}
              showSummary={true}
              summaryRows={3}
              summaryStyle={{
                paddingBottom: "10px",
                marginLeft: "15px",
                marginRight: "15px",
                color: "#666666",
                fontSize: "14px",
                lineHeight: "20px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              hoverStyle=""
              nodeId="node_ocl8zj6xio3"
              skin={0}
              itemStyle={{ border: "1px solid #e8e8e8" }}
            />
          </LayoutComponent>
        </Container>
        <Container
          width={1200}
          isCenter={true}
          hoverStyle=""
          nodeId="node_ocl988i9ym1"
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl9899vnz1g2"
            hoverStyle=""
            style={{ paddingBottom: "20px" }}
          >
            <Row
              isCenter={true}
              justifyContent="flex-start"
              alignItems="stretch"
              style={{ marginBottom: "20px" }}
            >
              <Col
                width={{ size: "1", type: "flex" }}
                style={{ marginRight: "10px" }}
              />
            </Row>
            <Title
              text="04 公益项目在行动"
              height={50}
              image="https://x0.ifengimg.com/ucms/2024_44/9545C89EE879A9C743743B61C88DA0DC7AFF5117_size1_w1000_h70.png"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "24px",
                color: "#ffffff",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm3"
              textIconHeightFull={true}
            />
            <NewsList_11
              chips={{
                newsChip: {
                  title: "新闻内容",
                  id: "",
                  type: "recommend",
                  defaultId: "285873",
                  uuid: "04b973b4",
                },
              }}
              colNum={1}
              colPadding={35}
              showColBorder={true}
              itemStyle={{ paddingTop: "15px", paddingBottom: "15px" }}
              itemAlignCenter={false}
              itemHoverColor="#ba2636"
              showThumbnail={true}
              thumbnailWidth={122}
              thumbnailHeight={122}
              showThumbnailHoverScale={true}
              titleStyle={{
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
              }}
              showSummary={true}
              summaryStyle={{
                color: "#666666",
                fontSize: "14px",
                lineHeight: "24px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              newsChip={{
                $data: true,
                id: "288570",
                type: "recommend",
                title: "新闻内容",
                format: {
                  filter: [
                    "thumbnails",
                    "title",
                    "type",
                    "url",
                    "base62Id",
                    "summary",
                    "children",
                    "position",
                    "newsTime",
                  ],
                },
                default: { type: "recommend", id: "285873" },
                uuid: "8a65e1ca",
                force: 1739785677323,
              }}
              showTime={false}
              nodeId="node_ocl75lh7p87"
              skin={0}
              timeStyle={{
                color: "#666666",
                fontSize: "12px",
                lineHeight: "24px",
              }}
              hoverStyle=""
              style={{ paddingLeft: "20px", paddingRight: "20px" }}
            />
            <Title
              text="05 精彩图片"
              height={50}
              image="https://x0.ifengimg.com/ucms/2024_44/9545C89EE879A9C743743B61C88DA0DC7AFF5117_size1_w1000_h70.png"
              textAlign="flex-start"
              textStyle={{
                paddingLeft: "24px",
                fontWeight: 700,
                fontSize: "24px",
                color: "#ffffff",
              }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm3"
              textIconHeightFull={true}
            />
            <Swiper_4
              swiperChip={{
                $data: true,
                id: "288657",
                type: "recommend",
                title: "轮播图内容",
                default: { type: "recommend", id: "285993" },
                uuid: "c2dcca3f",
                force: 1730106507843,
              }}
              slidesPerView={4}
              gap={5}
              height={437}
              isHasNav={false}
              leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
              rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
              navWidth={22}
              navHeight={40}
              navY={290}
              navX={15}
              isAutoPlay={true}
              autoSpeed={3000}
              nodeId="node_ocm2sp7v832"
            />
          </LayoutComponent>
        </Container>
        <Footer year="2022" style={{ marginTop: "70px" }} hoverStyle="" />
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
